import { render, staticRenderFns } from "./shoe-type.vue?vue&type=template&id=a27b48e2&scoped=true"
import script from "./shoe-type.vue?vue&type=script&lang=js"
export * from "./shoe-type.vue?vue&type=script&lang=js"
import style0 from "./shoe-type.vue?vue&type=style&index=0&id=a27b48e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27b48e2",
  null
  
)

export default component.exports